<div class="quote-speed-dial-fab">
  <lx-quote-cta-button icon="dots" (buttonClicked)="onToggleFab()" (click)="$event.stopPropagation()"></lx-quote-cta-button>

  <div *ngIf="showOptions" [@speedDialStagger]="showOptions">
    <lx-quote-cta-button-group
      class="quote-speed-dial-fab__action-buttons"
      [hasProductInfo]="hasProductInfo"
      [isProductEditable]="isProductEditable"
      (infoButtonClicked)="infoFabClicked.emit()"
      (editButtonClicked)="editFabClicked.emit()"
      (removeButtonClicked)="removeFabClicked.emit()"
    ></lx-quote-cta-button-group>
  </div>
</div>
